import { Flex, Modal, Space, Table ,App} from 'antd';
import React, { useEffect } from 'react'  
import {useState} from 'react'
import {useYhDelMutation, useYhListQuery} from '../../store/BnsKeJiApi';
import ClientEdit from '../client/ClientEdit';
import ModalDel from '../../cpn/ModalDel';
import ClientAdd from '../client/ClientAdd';
import ClientCheck from '../client/ClientCheck';
import { DesktopOutlined } from '@ant-design/icons';
function ProjectCheck(props) {
    const {message} = App.useApp()
    const [open,setOpen] = useState()
    const [list,setList] = useState([])
    const [del] = useYhDelMutation()
    const columns = [       
        {
            key: 'yh_image',
            title: '头像',            
            dataIndex: 'yh_image',           
            render: (text) => {
                return <img src={`/api/assets/images/application/${text}`} alt="头像" width={100} height={100}/>
            }
        },
        {
            key: 'yh_name',
            title: '客户端',
            dataIndex: 'yh_name',  
            render:(_,record) =>    <ClientCheck
                                        yh_id={record.key}
                                        yh_name={record.yh_name}
                                        bxm_id={props.bxm_id} 
                                        bxm_name={props.bxm_name}
                                        eu_id={props.eu_id}
                                        eu_name={props.eu_name}
                                        yh_content={record.yh_content}
                                    />
        }, 
        {
            key: 'yh_content',
            title: '说明',            
            dataIndex: 'yh_content',           
            render: (text) => {
                return <div dangerouslySetInnerHTML={{__html:text}}></div>
            }
        },
        
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.yh_ctime + record.yh_uname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            width: '12%',
            render: (_, record) => {
                return <>
                    <Space>  
                        <ClientEdit yh_id={record.key} bxm_id={props.bxm_id} bxm_name={props.bxm_name} eu_id={props.eu_id} eu_name={props.eu_name}/>
                        <ModalDel onOk={() => {
                                                del({yh_id:record.key}).then((res) => {
                                                    console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />                         
                    </Space>
                </>
            }
        },     
    ];
    const {data, isSuccess} = useYhListQuery({yh_xm_id:props.bxm_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {yh_id:key,yh_name,yh_ctime,yh_uname,yh_content,yh_bxm_name,yh_bxm_id,yh_image} = item;
                    return item = {key,yh_name,yh_ctime,yh_uname,yh_content,yh_bxm_name,yh_bxm_id,yh_image}
                })                
                let sorrArr = newArr.sort((a, b) => {
                    // 提取yh_name的第一个数字
                    const getFirstNumber = (name) => {
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.yh_name);
                    const numB = getFirstNumber(b.yh_name);
                    
                    return numA - numB;
                });
                setList(sorrArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])  
    return (
        <>
            <a onClick={() => {
                setOpen(true)}}><DesktopOutlined /> 客户端</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                width={1200}
                onCancel={() => {setOpen(false);}}                        
                footer={null}
                title={props.bxm_name + " - 客户端列表"}
            >
                <Flex justify='flex-end'>
                    <ClientAdd
                        bxm_id={props.bxm_id}
                        bxm_name={props.bxm_name}
                        eu_id={props.eu_id}
                        eu_name={props.eu_name}
                    />
                </Flex>
                <Table
                    columns={columns}
                    dataSource={list}
                    rowKey="key"                    
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
                    }}
                />
            </Modal>
            
        </>
    )
}

export default ProjectCheck